"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerInviteUserModal = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
const validationUtils = __importStar(require("../../utils/validationUtils"));
const ValidationErrors_1 = require("../ValidationErrors");
class ValidationErrorsManagerInviteUserModal extends ValidationErrors_1.ValidationErrors {
    constructor() {
        super(...arguments);
        this.nameInvalid = "";
        this.emailWrongFormat = "";
    }
}
const ManagerInviteUserModal = (props) => {
    const [email, setEmail] = (0, react_1.useState)("");
    const [name, setName] = (0, react_1.useState)("");
    const [isAdmin, setIsAdmin] = (0, react_1.useState)(false);
    const [showErrors, setShowErrors] = (0, react_1.useState)(false);
    const [validationErrors, setValidationErrors] = (0, react_1.useState)(new ValidationErrorsManagerInviteUserModal());
    // Validate when name or email changes.
    (0, react_1.useEffect)(() => {
        setValidationErrors(validate(name, email));
    }, [name, email]);
    function handleClose() {
        props.onClose();
    }
    function handleOk(e) {
        e.preventDefault();
        if (!showErrors) {
            // User clicked button for the first time. Show validation on next render.
            setShowErrors(true);
        }
        if (!validationErrors.hasErrors()) {
            props.onOk(email, name, isAdmin);
        }
    }
    return (react_1.default.createElement(Modal_1.default, { className: "manager-invite-user-modal", show: true, onHide: handleClose, animation: false, centered: true },
        react_1.default.createElement(Form_1.default, { onSubmit: handleOk, noValidate: true },
            react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
                react_1.default.createElement(Modal_1.default.Title, null, "Benutzer hinzuf\u00FCgen")),
            react_1.default.createElement(Modal_1.default.Body, null,
                react_1.default.createElement(Form_1.default.Group, { controlId: "name" },
                    react_1.default.createElement(Form_1.default.Label, null, "Vor- und Nachname"),
                    react_1.default.createElement(Form_1.default.Control, { type: "text", value: name, onChange: (e) => setName(e.target.value), isInvalid: showErrors && validationErrors.nameInvalid !== "" }),
                    react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.nameInvalid)),
                react_1.default.createElement(Form_1.default.Group, { controlId: "email" },
                    react_1.default.createElement(Form_1.default.Label, null, "E-Mail"),
                    react_1.default.createElement(Form_1.default.Control, { type: "email", value: email, onChange: (e) => setEmail(e.target.value), isInvalid: showErrors && validationErrors.emailWrongFormat !== "" }),
                    react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.emailWrongFormat)),
                react_1.default.createElement(Form_1.default.Check, { type: "switch", id: "admin-switch", label: "Administrator", checked: isAdmin, onChange: (e) => setIsAdmin(e.target.checked) })),
            react_1.default.createElement(Modal_1.default.Footer, null,
                react_1.default.createElement(Button_1.default, { type: "submit", variant: "primary", disabled: showErrors && validationErrors.hasErrors(), style: { minWidth: "110px" } }, "Ok"),
                react_1.default.createElement(Button_1.default, { className: "", variant: "secondary", style: { minWidth: "110px" }, onClick: handleClose }, "Schliessen")))));
};
exports.ManagerInviteUserModal = ManagerInviteUserModal;
function validate(name, email) {
    const errors = new ValidationErrorsManagerInviteUserModal();
    if (name.trim().length < 5) {
        errors.nameInvalid = "Bitte gültigen Namen angeben.";
    }
    if (!validationUtils.validEmail(email)) {
        errors.emailWrongFormat = "Bitte gültige E-Mail Adresse angeben.";
    }
    return errors;
}
